module.exports = __webpack_public_path__ + "static/media/img-03.1a75fa74.jpg";